// flow
import Button from './../components/buttons';
import { Flex } from './../components/layout/Grid';
import { Trans } from '@lingui/react';

const LoadMoreSection = ({
  'data-testid': dataTestId = 'LoadMoreSection',
  ...props
}) => {
  return props.data?.totalCount / props.data?.perPage > props.data?.page ? (
    <Flex mb="20px" mt="20px" justifyContent="center" data-testid={dataTestId}>
      <Button
        appearance="outline"
        loading={props.loading}
        onClick={props.onLoadMoreClick}
        spinnerColor="#7d7d7d"
        data-testid="LoadMoreSection--btn"
      >
        <Trans id="metadata.show_more" message="Show more" />
      </Button>
    </Flex>
  ) : null;
};

export default LoadMoreSection;
